import { FC, useMemo, memo } from 'react'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { categoriesGroupsSelector } from 'selectors/globalSelectors'
import { CategoryId } from 'interfaces/meta'
import { ALL_MONEYFLOW_CATEGORY, ALL_ACCOUNT_CATEGORY } from 'helpers/rawHelpers'
import { CategorizedPage } from 'interfaces/pages'
import { isAccountPage } from 'helpers/pageHelpers'
import { Category } from 'components/features/pfm/CategoriesMenu/Category'
import { CategoriesGroup } from 'components/features/pfm/CategoriesMenu/CategoriesGroup'

type CategoriesMenuProps = {
  selectedId: CategoryId
  type: CategorizedPage
  allowAllCategories?: boolean
  allowGroups?: boolean
  onSelect?: (selectedId: CategoryId) => void
}

export const CategoriesMenu: FC<CategoriesMenuProps> = memo((props) => {
  const {
    selectedId,
    allowAllCategories,
    allowGroups = true,
    onSelect,
    type,
  } = props

  const groups = useStoreSelector((state) => categoriesGroupsSelector(state, props))

  const allCategory = useMemo(() => {
    if (!allowAllCategories) {
      return null
    } else if (isAccountPage(type)) {
      return ALL_ACCOUNT_CATEGORY
    } else {
      return ALL_MONEYFLOW_CATEGORY
    }
  }, [type, allowAllCategories])

  return (
    <>
      { allCategory && (
        <Category
          category={ allCategory }
          selectedId={ selectedId }
          onSelect={ onSelect }
        />
      )}
      { groups.map((group) => (
        <CategoriesGroup
          key={ group.id }
          group={ group }
          selectedId={ selectedId }
          allowGroups={ allowGroups }
          onSelect={ onSelect }
        />
      )) }
    </>
  )
})
